export const LEGACY_ENGINE_CLASS = 'legacy-engine'

const ENGINE_QUERY_PARAM = 'engine'

/** Must select the same engines as the inline gate in buildSrc/legacyFallbackStylesheetPlugin.ts. True on a Chrome-52-class engine (no `:focus-visible`), or when `?engine=legacy` forces it for local testing. */
export function isLegacyEngine(): boolean {
    if (new URLSearchParams(location.search).get(ENGINE_QUERY_PARAM) === 'legacy') return true
    return (
        typeof CSS !== 'undefined' &&
        typeof CSS.supports === 'function' &&
        !CSS.supports('selector(:focus-visible)')
    )
}
